// 材料账户V2 - 列表表格配置
export const materialAccountV2TableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: false,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "balance",
    order: "ascending",
  },
  column: [
    {
      label: "施工员姓名",
      prop: "userName",
      placeholder: "请输入施工员姓名",
      search: true,
      type: "input",
    },
    {
      label: "施工员手机号",
      prop: "userMobile",
      placeholder: "请输入施工员手机号",
      search: true,
      type: "input",
    },
    {
      label: "余额(元)",
      prop: "balance",
      type: "input",
      formatter: (row) => {
        return row.balance != null ? Number(row.balance).toFixed(2) : "0.00";
      },
    },
    {
      label: "刚性余料(元)",
      prop: "rigidSurplus",
      type: "input",
      formatter: (row) => {
        return row.rigidSurplus != null ? Number(row.rigidSurplus).toFixed(2) : "0.00";
      },
    },
    {
      label: "柔性余料(元)",
      prop: "flexSurplus",
      type: "input",
      formatter: (row) => {
        return row.flexSurplus != null ? Number(row.flexSurplus).toFixed(2) : "0.00";
      },
    },
  ],
};

// 材料账户V2 - 明细表格配置
export const materialAccountV2DetailTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: false,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "操作类型",
      prop: "type",
      type: "select",
      search: true,
      dicData: [
        { label: "充值", value: "RECHARGE" },
        { label: "核销领料", value: "ACTUAL_PICKUP" },
        { label: "标准用料结算", value: "STANDARD_USAGE" },
        { label: "标准用料结算", value: "OVER_CAP_BONUS" },
        { label: "提交结算", value: "SETTLE_ON_SUBMIT" },
        { label: "终审拒绝冲账", value: "SETTLE_REVERSE" },
      ],
      formatter: (row) => {
        const typeMap = {
          RECHARGE: "充值",
          ACTUAL_PICKUP: "核销领料",
          STANDARD_USAGE: "标准用料结算",
          OVER_CAP_BONUS: "标准用料结算",
          SETTLE_ON_SUBMIT: "提交结算",
          SETTLE_REVERSE: "终审拒绝冲账",
        };
        return typeMap[row.type] || row.type;
      },
    },
    {
      label: "材料类型",
      prop: "materialType",
      type: "select",
      dicData: [
        { label: "刚性", value: "RIGID" },
        { label: "柔性", value: "FLEXIBLE" },
        { label: "通用", value: "COMMON" },
      ],
      formatter: (row) => {
        const typeMap = {
          RIGID: "刚性",
          FLEXIBLE: "柔性",
          COMMON: "通用",
        };
        return typeMap[row.materialType] || row.materialType;
      },
    },
    {
      label: "操作金额(元)",
      prop: "amount",
      type: "input",
      formatter: (row) => {
        if (row.amount == null) return "0.00";
        const val = Number(row.amount);
        const str = val.toFixed(2);
        // 正数显示为绿色+号，负数显示为红色
        if (val > 0) return "+" + str;
        return str;
      },
    },
    {
      label: "操作后余额(元)",
      prop: "balance",
      type: "input",
      formatter: (row) => {
        return row.balance != null ? Number(row.balance).toFixed(2) : "0.00";
      },
    },
    /* {
      label: "关联工单ID",
      prop: "orderId",
      type: "input",
      overHidden: true,
    },
    {
      label: "领料频次",
      prop: "freq",
      type: "input",
    }, */
    {
      label: "备注",
      prop: "remarks",
      type: "input",
      overHidden: true,
    },
    {
      label: "操作时间",
      prop: "createTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      search: false,
    },
  ],
};
